<template>
  <div>
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew"><span></span><span></span><span></span><span></span></div>
      <div class="container pt-lg pb-300">
          <div class="row text-center justify-content-center">
              <div class="col-lg-10">
                  <h2 class="display-3 text-white">Curso Aprenda do Zero Tudo Sobre Bitcoin</h2>
                  <p class="lead text-white">Você vai descobrir que é muito fácil aprender a investir em Bitcoins e outras criptomoedas</p>
              </div>
          </div>
      </div>
    </section>

    <section class="section section-lg pt-lg-0 section-contact-us">
        <div class="container">
            <div class="row justify-content-center mt--300">
                <div class="col-lg-8">
                    <div class="card shadow bg-gradient-secondary">
                        <div class="card-body p-lg-5">
                            <h4 class="mb-1">Cadastre seu e-mail e receba gratuitamente a primeira aula do curso: O que é Bitcoin?</h4>

                            <!-- Begin Mailchimp Signup Form -->
                            <div id="mc_embed_signup">
                            <form action="https://ensinandobitcoin.us16.list-manage.com/subscribe/post?u=7be9462b20e2907ad802c2884&amp;id=209a87e87b" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                                <div id="mc_embed_signup_scroll">

                            <div class="form-group mt-5 input-group input-group-alternative mc-field-group">
                              <div class="input-group-prepend"><span class="input-group-text"><i class="ni ni-email-83"></i></span></div>
                              <input placeholder="Qual o seu e-mail?" class="form-control required email" type="email" value="" name="EMAIL" id="mce-EMAIL">

                            </div>
                            <div class="form-group input-group input-group-alternative mc-field-group">
                              <div class="input-group-prepend"><span class="input-group-text"><i class="ni ni-circle-08"></i></span></div>
                              <input placeholder="Qual o seu nome? (opcional)" class="form-control" type="text" value="" name="FNAME" id="mce-FNAME">
                            </div>
                            <div id="mergeRow-gdpr" class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
                                <div class="content__gdpr">
                                    <fieldset class="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">
                            		<label class="checkbox subfield" for="gdpr_24431"><input type="checkbox" id="gdpr_24431" name="gdpr[24431]" value="Y" class="av-checkbox gdpr"><span> Aceito receber e-mails sobre o curso Aprenda do Zero Tudo Sobre Bitcoin</span> </label>
                                    </fieldset>
                                </div>
                            </div>
                            	<div id="mce-responses" class="clear">
                            		<div class="response" id="mce-error-response" style="display:none"></div>
                            		<div class="response" id="mce-success-response" style="display:none"></div>
                            	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                                <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_7be9462b20e2907ad802c2884_209a87e87b" tabindex="-1" value=""></div>
                                <div class="clear">

                                  <input type="submit" value="Cadastre-se e receba a primeira aula" name="subscribe" id="mc-embedded-subscribe" class="mt-3 btn btn-block btn-warning btn-lg" style="white-space:unset;">

                                </div>
                                <div class="mt-5 content__gdprLegal">
                                    <small>Você poderá interromper o envio a qualquer momento. Basta clicar no link disponibilizado no rodapé de nossos e-mails.</small><br />
                                    <small>A Ensinando Bitcoin utiliza a plataforma MailChimp para gestão e armazenamento dos seus dados.<br /><a href="https://mailchimp.com/legal/" target="_blank">Conheça as práticas de privacidade da MailChimp aqui.</a></small>
                                </div>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Squeeze',
  components: {

  },
  data(){
    return {
    }
  }
};
</script>

<style scoped lang="scss">
h1 {
  font-size: 3.3rem;
}

@media (min-width: 576px) {
  h1 {
    font-size: 3.3rem;
  }
}

@media (min-width: 768px) {
  h1 {
    font-size: 3.3rem;
  }
}

@media (min-width: 1200px) {
  h1 {
    font-size: 4.5rem;
  }
}

.inverted-image {
  filter: invert(1);
  mix-blend-mode: screen;
}
</style>
